<template>
    <div>
        <table>
            <tr>
                <th>Item</th>
                <th>SKU</th>
                <th>Qty</th>
                <th>KG</th>
                <th>WLH</th>
                <th>Box</th>
            </tr>
            <tr v-for="line in lines" :key="line.id" class="ion-activatable ripple-parent">
                <td class="truncate">{{ line.item.item_number }}</td>
                <td class="truncate">{{ line.sku.sku }}</td>
                <td>
                    <ion-text :color="line.checking.qty_unboxed < 1?'su ccess':''">
                        {{ line.checking.qty_boxed }}
                    </ion-text>
                    /
                    <ion-text :color="line.checking.qty_unboxed < 1?'success':'danger'">
                        {{ line.checking.qty_unboxed }}
                    </ion-text>
                </td>
                <td>{{ boxData(line).weight }}</td>
                <td class="truncate">{{ boxData(line).dimensions }}</td>
                <td>
                    <ion-button @click="showLineDetails(line)" size="small" fill="outline" expand="block" v-if="boxData(line).numbers?.length > 0">
                        {{ boxData(line).numbers.join(',') }}
                    </ion-button>
                    <div v-else class="spacer"></div>
                </td>
            </tr>
        </table>
        <shipment-line-boxes-modal
            ref="boxes"
            :shipment="shipment"
            @updated="$emit('updated')"
        />
    </div>
</template>

<script>
import {IonText, IonButton} from '@ionic/vue';
import ShipmentLineBoxesModal from "@/views/modules/checking/pages/check/modals/ShipmentLineBoxesModal";
import _, {filter} from 'lodash';

export default {
    name: "BoxManifestTable",
    inject: ['$http', '$validationAlert'],
    props: ['shipment', 'current-shipment-split', 'filter'],
    emits: ['updated'],
    components: {ShipmentLineBoxesModal, IonText, IonButton},
    computed: {
        lines() {


            const lines = filter(this.shipment.lines, line => {
                return !line.is_child;
            });

            if (this.filter.length < 1) {
                return this.shipment.lines;
            }
            const filtered = _.filter(lines, line => {
                let found = 0;
                found += line.sku.sku.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                found += line.sku.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                found += line.item.item_number.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                return found > 0;
            });

            if (!this.currentShipmentSplit) {
                return filtered;
            }

            return filter(filtered, line => {
                return typeof line?.checking?.boxes[this.currentShipmentSplit.reference] !== 'undefined';
            });
        }
    },
    methods: {
        boxData(line) {
            if (this.currentShipmentSplit) {
                return line.checking.boxes[this.currentShipmentSplit.reference];
            }
            return line.checking.boxes;
        },
        showLineDetails(line) {
            this.$refs.boxes.open(
                line,
                this.currentShipmentSplit?this.currentShipmentSplit.reference:null
            );
        }
    }
}
</script>

<style scoped>

td.truncate {
    word-break: break-all;
    width: 20%;
}

ion-button {
    margin: 0;
}

.spacer {
    text-align: center;
    min-height: 28px;
}
</style>
